module.exports = __webpack_public_path__ + "static/img/newsbannerthree.b2826e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsbannerthree.jpg
// module id = UVwx
// module chunks = 45